export default {
  items: [
    {
      divider: true
    },
    {
      divider: true
    },
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      name: 'GAD Analytics',
      url: '/analytics',
      icon: 'icon-graph',
      children: [
        {
          name: 'Dashboard',
          url: '/analytics/dashboard',
          icon: 'icon-speedometer'
        },
        {
          name: 'Report',
          url: '/analytics/report',
          icon: 'icon-docs'
        },
        {
          name: 'Systems',
          url: '/analytics/systems',
          icon: 'fa fa-server'
        }
      ]
    },
    {
      name: 'Issue Tracker',
      url: '/issue-tracker',
      icon: 'fa fa-bug',
      children: [
        {
          name: 'Dashboard',
          url: '/issue-tracker/dashboard',
          icon: 'icon-speedometer'
        },
        {
          name: 'Issue List',
          url: '/issue-tracker/list',
          icon: 'icon-list'
        },
        {
          name: 'Create Issue',
          url: '/issue-tracker/create',
          icon: 'icon-plus'
        },
        {
          name: 'Team Members',
          url: '/issue-tracker/team-members',
          icon: 'fa fa-users'
        },
        {
          name: 'Systems',
          url: '/issue-tracker/systems',
          icon: 'fa fa-server'
        }
      ]
    },
    {
      name: 'Monitoring',
      url: '/monitoring',
      icon: 'icon-chart',
      children: [
        {
          name: 'Dashboard',
          url: '/monitoring/dashboard',
          icon: 'fa fa-pie-chart',
          badge: {variant: 'primary', text: 'NEW'}
        },
        {
          name: 'Live Monitoring',
          url: '/monitoring/live',
          icon: 'icon-speedometer'
        },
        {
          name: 'Downtime Reports',
          url: '/monitoring/reports',
          icon: 'icon-docs'
        },
        {
          name: 'Downtime Entry',
          url: '/monitoring/downtime-entry',
          icon: 'icon-pencil'
        },
        {
          name: 'Systems',
          url: '/monitoring/systems',
          icon: 'fa fa-server'
        }
      ]
    },
    {
      name: 'Customers',
      url: '/customers',
      icon: 'icon-people',
      children: [
        {
          name: 'Office List',
          url: '/customers/list',
          icon: 'icon-list'
        },
        {
          name: 'Office Modules',
          url: '/customers/modules',
          icon: 'icon-layers'
        },
				{
					name: 'Create Client',
					url: '/customers/create-client',
					icon: 'icon-user-follow',
					badge: {
						variant: 'primary',
						text: 'NEW'
					}
				},
				{
					name: 'Create Project',
					url: '/customers/create-project',
					icon: 'icon-home'
				},
				{
					name: 'Create Office',
					url: '/customers/create-office',
					icon: 'icon-home'
				},
				{
					name: 'Group of Companies',
					url: '/customers/company-groups',
					icon: 'fa fa-users'
				},
				{
					name: 'Companies',
					url: '/customers/companies',
					icon: 'icon-home'
				},

      ]
    },
    {
      // Parent URL is the section root so router-link-active matches every child and the dropdown
      // stays open across navigation. It is /tipsoi-pay rather than /pay on purpose: /pay is a
      // string prefix of /payroll, and vue-router's inclusive match would hold this menu open on
      // every Payroll page. See the note in router/index.js.
      name: 'Tipsoi Pay',
      url: '/tipsoi-pay',
      icon: 'fa fa-credit-card',
      children: [
        {
          name: 'Dashboard',
          url: '/tipsoi-pay/dashboard',
          icon: 'fa fa-tachometer',
          badge: {variant: 'primary', text: 'NEW'}
        },
        {
          name: 'Clients',
          url: '/tipsoi-pay/clients',
          icon: 'fa fa-users'
        },
        {
          name: 'Items',
          url: '/tipsoi-pay/items',
          icon: 'fa fa-tags'
        },
        {
          name: 'Billing Setup',
          url: '/tipsoi-pay/legacy/setup',
          icon: 'icon-wrench'
        },
        {
          name: 'Invoice',
          url: '/tipsoi-pay/legacy/invoice',
          icon: 'fa fa-file-text-o'
        },
        {
          name: 'Payment',
          url: '/tipsoi-pay/legacy/payment',
          icon: 'fa fa-dollar'
        },
        {
          name: 'Due Status',
          url: '/tipsoi-pay/legacy/due-status',
          icon: 'fa fa-dollar'
        }
      ]
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'icon-settings',
      children: [
        {
          name: 'Version',
          url: '/settings/version',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Module',
          url: '/settings/module',
          icon: 'fa fa-cubes'
        },
        {
          name: 'Version Configurator',
          url: '/settings/configurator',
          icon: 'fa fa-cogs'
        }
      ]
    },
		{
			name: 'Resellers',
			url: '/resellers',
			icon: 'icon-people',
			children: [
				{
					name: 'List',
					url: '/resellers/list',
					icon: 'icon-list'
				}
			]
		},
		{
			name: 'Orders',
			url: '/purchase-orders',
			icon: 'fa fa-file-text',
			children: [
				{
					name: 'P.O. List',
					url: '/purchase-orders/list',
					icon: 'icon-list'
				},
				{
					name: 'Create P.O.',
					url: '/purchase-orders/create',
					icon: 'icon-plus'
				},
				{
					name: 'Delivery Receipt',
					url: '/purchase-orders/delivery-receipts/create',
					icon: 'fa fa-truck'
				}
			]
		},
		{
			name: 'Customer Support',
			url: '/customer-support',
			icon: 'fa fa-file-text',
			children:[
				{
					name: 'Password Reset',
					url: '/customer-support/password-reset',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Support Management',
					url: '/customer-support/support-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Clone Temporary Allocations',
					url: '/customer-support/temporary-allocations/clone',
					icon: 'fa fa-clone'
				},
				{
					name: 'Report Archive',
					url: '/customer-support/report-archive',
					icon: 'fa fa-archive'
				}
			]
		},
		{
			name: 'Payroll',
			url: '/payroll',
			icon: 'fa fa-file-text',
			children:[
				{
					name: 'Payroll Manager',
					url: '/payroll/payroll-manager',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Provident Fund',
					url: '/payroll/provident-fund',
					icon: 'fa fa-life-ring'
				}

			]
		},
		{
			name: 'General Settings',
			url: '/general-settings',
			icon: 'fa fa-file-text',
			children:[
				{
					name: 'Mobile Punch Settings',
					url: '/general-settings/mobile-punch',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Overtime Settings',
					url: '/general-settings/overtime-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Fiscal Year Settings',
					url: '/general-settings/fiscal-year',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Report Settings',
					url: '/general-settings/report-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Parking Management',
					url: '/general-settings/parking-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Membership Management',
					url: '/general-settings/membership-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Site Management',
					url: '/general-settings/site-management',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Attendance Settings',
					url: '/general-settings/attendance-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Line Manager Settings',
					url: '/general-settings/line-manager-settings',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Location Tracking',
					url: '/general-settings/location-tracking',
					icon: 'fa fa-life-ring'
				},
				{
					name: 'Employee and Device Limits',
					url: '/general-settings/employee-device-limits',
					icon: 'fa fa-sliders'
				}
			]
		},
		{
			name: 'Subscription Request',
			url: '/subscription',
			icon: 'fa fa-file-text',
			children:[
				{
					name: 'Request List',
					url: '/subscription/request-list',
					icon: 'icon-list'
				}
			]
		},
		{
			// Parent url must be the section root, or _custom.scss's
			// `.sidebar .nav-dropdown.router-link-active > .nav-dropdown-items` rule
			// will not keep the dropdown open while a child is active.
			name: 'Application Logs',
			url: '/application-logs',
			icon: 'fa fa-terminal',
			children:[
				{
					name: 'Log Explorer',
					url: '/application-logs/explorer',
					icon: 'icon-list',
					badge: { variant: 'primary', text: 'NEW' }
				},
				{
					name: 'Log Sources',
					url: '/application-logs/sources',
					icon: 'icon-settings'
				},
				{
					name: 'Access Trail',
					url: '/application-logs/audit',
					icon: 'icon-shield'
				}
			]
		}
  ]
}
